import tw from "twin.macro";

export const SectionHeading = tw.h2`text-4xl  md:text-6xl  font-playfair`;
export const Heading = tw.h2`text-2xl  font-playfair`;
export const Subheading = tw.h5`text-xs text-blue-300 `;
export const Paragraph = tw.h5`text-smm my-2 opacity-70 `;

export const TestimonialHeading = tw.h2`text-2xl sm:text-3xl font-semibold tracking-wide text-center  font-playfair`;
